var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85001 4.5C2.16968 4.5 1.61744 4.99311 1.51651 5.60955L10.1565 11.3695C10.1631 11.3738 10.1696 11.3781 10.176 11.3826L12.0001 12.5986L13.817 11.3873C13.828 11.3796 13.8391 11.3722 13.8504 11.3651L22.4835 5.60965C22.3826 4.99316 21.8304 4.5 21.15 4.5H2.85001ZM14.25 12.9014L12.4161 14.124C12.1642 14.292 11.836 14.292 11.5841 14.124L9.75002 12.9013L1.51649 18.3904C1.61739 19.0068 2.16964 19.5 2.85001 19.5H21.15C21.8303 19.5 22.3826 19.0069 22.4835 18.3904L14.25 12.9014ZM22.5 16.5987L15.6021 12.0001L22.5 7.40143V16.5987ZM24 18V6.01477C24.0002 6.00447 24.0002 5.99415 24 5.98383V5.8125C24 4.25123 22.7064 3 21.15 3H2.85001C1.29359 3 6.85183e-06 4.25123 6.85183e-06 5.8125V17.9852C-0.000205506 17.9955 -0.000205963 18.0058 6.85183e-06 18.0162V18.1875C6.85183e-06 19.7488 1.29359 21 2.85001 21H21.15C22.7064 21 24 19.7488 24 18.1875V18.0014C24 18.0009 24 18.0005 24 18ZM1.50001 16.5986L8.39794 11.9999L1.50001 7.40132V16.5986Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailTemplate);
export default __webpack_public_path__ + "static/media/email-template.e5eeac9536e330bc67cfb3fc31dea7e8.svg";
export { ForwardRef as ReactComponent };